import React, { useEffect, useState } from "react";
import FailedBatchesTable from "./table";
import { settingServices } from "Utils/setting/services";
import BreadCrumb from "Common/BreadCrumb";
import "./styles.scss";

const FailedBatchesReport: React.FC = () => {
  const [status, setStatus] = useState<string>("");
  const [selectedAll, setSelectedAll] = useState(false);

  const getBatchesFailedData = async (customStatus?: string) => {
    try {
      const payload: batchesListPayload = customStatus
        ? { status: customStatus }
        : ({} as batchesListPayload);

      const { response } = await settingServices.getBatchesList(payload);
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getBatchesFailedData();
  }, []);
  const handleFilter = () => {
    getBatchesFailedData(status);
  };
  const handleClear = async () => {
    if (status) {
      setStatus("");
      await getBatchesFailedData(""); 
    } else {
      console.log("No status to clear.");
    }
  };

  return (
    <div className="page-content">
      <div className="closed-user inner-content">
        <BreadCrumb title="Failed Batches" pageTitle="Dashboard" back />
        <div className="card">
          <form noValidate className="card-body">
            <div className="row">
              <div className="col-md-3 px-1">
                <div className="form-group">
                  <select
                    className="form-select"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="FAILED">FAILED</option>
                    <option value="SUCCESS">SUCCESS</option>
                  </select>
                </div>
              </div>
              <div className="col-md-3 px-1">
                <div className="col-inner">
                  <div className="btn-list">
                    <button
                      type="button"
                      className="btn btn-success me-3"
                      onClick={handleFilter}
                    >
                      Filter
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={handleClear}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <FailedBatchesTable
          selectedAll={selectedAll}
          onToggleSelectAll={setSelectedAll}
        />
      </div>
    </div>
  );
};

export default FailedBatchesReport;
